import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import RejectionNoticeModal from '../common/RejectionNoticeModal';

const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, loading, signedOut } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner message="Authenticating..." />;
  }

  if (!isAuthenticated) {
    // The bare home URL is the normal entry point; specific destinations take priority.
    const isDefaultEntry = location.pathname === '/' && !location.search && !location.hash;
    return <Navigate to="/login" state={signedOut || isDefaultEntry ? null : { from: location }} replace />;
  }

  // Keep the legacy dedicated page inaccessible unless the account still has the flag
  if (!user?.forcePasswordReset && location.pathname === '/force-password-change') {
    return <Navigate to="/" replace />;
  }

  // Skip onboarding redirects while the account is still using a reset password.
  if (
    user?.onboardingRequired &&
    !user?.forcePasswordReset &&
    location.pathname !== '/onboarding/profession-type'
  ) {
    return <Navigate to="/onboarding/profession-type" replace />;
  }

  // If onboarding is NOT required but user tries to access it, redirect to home
  if (!user?.onboardingRequired && location.pathname === '/onboarding/profession-type') {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
      <RejectionNoticeModal />
    </>
  );
};

export default ProtectedRoute;
